export default (value) => new Intl.NumberFormat('es-PY', { style: 'currency', currency: 'PYG', currencyDisplay: 'symbol' }).format(value);
